/**
 * SQLite storage implementation for Capacitor mobile apps.
 *
 * TODO: Implement when adding mobile support
 *
 * Dependencies to add:
 * - @capacitor-community/sqlite
 *
 * This adapter will use SQL queries instead of Dexie's API,
 * but implement the same StorageAdapter interface.
 */
export class SQLiteStorage {
    async initialize() {
        throw new Error('SQLite storage not yet implemented. Use IndexedDB for web.');
    }
    async close() {
        throw new Error('SQLite storage not yet implemented.');
    }
    // Tasks
    async getTasks() {
        throw new Error('Not implemented');
    }
    async getTask(_id) {
        throw new Error('Not implemented');
    }
    async getTasksByProject(_projectId) {
        throw new Error('Not implemented');
    }
    async getTasksByStatus(_status) {
        throw new Error('Not implemented');
    }
    async saveTask(_task) {
        throw new Error('Not implemented');
    }
    async saveTasks(_tasks) {
        throw new Error('Not implemented');
    }
    async deleteTask(_id) {
        throw new Error('Not implemented');
    }
    // Projects
    async getProjects() {
        throw new Error('Not implemented');
    }
    async getProject(_id) {
        throw new Error('Not implemented');
    }
    async saveProject(_project) {
        throw new Error('Not implemented');
    }
    async deleteProject(_id) {
        throw new Error('Not implemented');
    }
    // Schedules
    async getSchedule(_date) {
        throw new Error('Not implemented');
    }
    async getSchedules(_startDate, _endDate) {
        throw new Error('Not implemented');
    }
    async saveSchedule(_schedule) {
        throw new Error('Not implemented');
    }
    async saveSchedules(_schedules) {
        throw new Error('Not implemented');
    }
    async deleteSchedule(_date) {
        throw new Error('Not implemented');
    }
    // Goals
    async getGoals() {
        throw new Error('Not implemented');
    }
    async getGoal(_id) {
        throw new Error('Not implemented');
    }
    async saveGoal(_goal) {
        throw new Error('Not implemented');
    }
    async deleteGoal(_id) {
        throw new Error('Not implemented');
    }
    // Notes
    async getNotes() {
        throw new Error('Not implemented');
    }
    async getNote(_id) {
        throw new Error('Not implemented');
    }
    async getNotesByFolder(_folder) {
        throw new Error('Not implemented');
    }
    async saveNote(_note) {
        throw new Error('Not implemented');
    }
    async deleteNote(_id) {
        throw new Error('Not implemented');
    }
    // Lists
    async getLists() {
        throw new Error('Not implemented');
    }
    async getList(_id) {
        throw new Error('Not implemented');
    }
    async saveList(_list) {
        throw new Error('Not implemented');
    }
    async deleteList(_id) {
        throw new Error('Not implemented');
    }
    // List Instances
    async getListInstances() {
        throw new Error('Not implemented');
    }
    async getListInstance(_id) {
        throw new Error('Not implemented');
    }
    async saveListInstance(_instance) {
        throw new Error('Not implemented');
    }
    async deleteListInstance(_id) {
        throw new Error('Not implemented');
    }
    // Habit Instances
    async getHabitInstance(_taskId, _date) {
        throw new Error('Not implemented');
    }
    async getHabitInstances(_date) {
        throw new Error('Not implemented');
    }
    async getHabitInstancesByHabit(_habitId, _startDate, _endDate) {
        throw new Error('Not implemented');
    }
    async getAllHabitInstances() {
        throw new Error('Not implemented');
    }
    async saveHabitInstance(_instance) {
        throw new Error('Not implemented');
    }
    async deleteHabitInstance(_habitId, _date) {
        throw new Error('Not implemented');
    }
    // Journal Entries
    async getJournalEntries() {
        throw new Error('Not implemented');
    }
    async getJournalEntry(_id) {
        throw new Error('Not implemented');
    }
    async getJournalEntriesByDate(_date) {
        throw new Error('Not implemented');
    }
    async getJournalEntriesByDateRange(_startDate, _endDate) {
        throw new Error('Not implemented');
    }
    async saveJournalEntry(_entry) {
        throw new Error('Not implemented');
    }
    async deleteJournalEntry(_id) {
        throw new Error('Not implemented');
    }
    // Reviews
    async getReviews() {
        throw new Error('Not implemented');
    }
    async saveReview(_review) {
        throw new Error('Not implemented');
    }
    async deleteReview(_id) {
        throw new Error('Not implemented');
    }
    // Fitness
    async getFitnessWorkouts() {
        throw new Error('Not implemented');
    }
    async saveFitnessWorkout(_workout) {
        throw new Error('Not implemented');
    }
    async deleteFitnessWorkout(_id) {
        throw new Error('Not implemented');
    }
    async getFitnessBodyweights() {
        throw new Error('Not implemented');
    }
    async saveFitnessBodyweight(_entry) {
        throw new Error('Not implemented');
    }
    async deleteFitnessBodyweight(_id) {
        throw new Error('Not implemented');
    }
    async getFitnessSettings() {
        throw new Error('Not implemented');
    }
    async saveFitnessSettings(_settings) {
        throw new Error('Not implemented');
    }
    // Mood Check-ins
    async getMoodCheckIns() {
        throw new Error('Not implemented');
    }
    async getMoodCheckIn(_id) {
        throw new Error('Not implemented');
    }
    async getMoodCheckInsByDate(_date) {
        throw new Error('Not implemented');
    }
    async getMoodCheckInsByDateRange(_startDate, _endDate) {
        throw new Error('Not implemented');
    }
    async saveMoodCheckIn(_moodCheckIn) {
        throw new Error('Not implemented');
    }
    async deleteMoodCheckIn(_id) {
        throw new Error('Not implemented');
    }
    // Preferences
    async getPreferences() {
        throw new Error('Not implemented');
    }
    async savePreferences(_preferences) {
        throw new Error('Not implemented');
    }
    // Stats
    async getStats() {
        throw new Error('Not implemented');
    }
    async saveStats(_stats) {
        throw new Error('Not implemented');
    }
    // Sync Metadata
    async getLastSyncTime() {
        throw new Error('Not implemented');
    }
    async setLastSyncTime(_time) {
        throw new Error('Not implemented');
    }
    async getPendingChanges() {
        throw new Error('Not implemented');
    }
    async addPendingChange(_change) {
        throw new Error('Not implemented');
    }
    async clearPendingChanges(_changeIds) {
        throw new Error('Not implemented');
    }
    // Tombstone Management
    async getTombstones() {
        throw new Error('Not implemented');
    }
    async addTombstone(_tombstone) {
        throw new Error('Not implemented');
    }
    async importTombstones(_tombstones) {
        throw new Error('Not implemented');
    }
    async cleanupTombstones(_olderThanDays) {
        throw new Error('Not implemented');
    }
    // Bulk Operations
    async exportAll() {
        throw new Error('Not implemented');
    }
    async importAll(_data) {
        throw new Error('Not implemented');
    }
    async clearAll() {
        throw new Error('Not implemented');
    }
}
//# sourceMappingURL=sqlite.js.map